<script setup lang="ts">
    import { useEditCoachingFormStore } from '@/js/stores/edit-coaching-form';
    import CheckboxInput from '../CheckboxInput.vue';
    import FormGroup from '../FormGroup.vue';
    import { watch } from 'vue';
    import InputLabel from '../InputLabel.vue';
    import TextInput, { TextInputWidth } from '../TextInput.vue';
    import TextareaInput from '../TextareaInput.vue';
    import { storeToRefs } from 'pinia';
    import { __ } from '@/js/stores/expressions';

    const { formDraft } = storeToRefs(useEditCoachingFormStore());

    watch(
        () => formDraft.value?.useRestrictedComment,
        () => {
            if (!formDraft.value?.useRestrictedComment) {
                delete formDraft.value?.restrictedComment;
            } else {
                if (!formDraft.value?.restrictedComment) {
                    formDraft.value.restrictedComment = {
                        title: '',
                        description: '',
                    };
                }
            }
        }
    );
</script>

<template>
    <div v-if="formDraft">
        <FormGroup>
            <template #header>
                {{ __('coaching-form-restricted-comment-header') }}
            </template>
            <template #help>
                <p>
                    {{ __('coaching-form-restricted-comment-help-text') }}
                </p>
            </template>

            <CheckboxInput id="form-restricted-comment" v-model="formDraft.useRestrictedComment">
                {{ __('coaching-form-use-restricted-comment') }}
            </CheckboxInput>
        </FormGroup>

        <div
            v-if="formDraft.useRestrictedComment && formDraft.restrictedComment"
            class="mt-4 bg-gray-extralight p-6 rounded-md"
        >
            <FormGroup>
                <div>
                    <InputLabel for="form-restricted-comment-title">
                        {{ __('title') }}
                    </InputLabel>
                    <TextInput
                        id="form-restricted-comment-title"
                        v-model="formDraft.restrictedComment.title"
                        :width="TextInputWidth.Large"
                    />
                </div>
                <div>
                    <InputLabel for="form-restricted-comment-description">
                        {{ __('description') }}
                    </InputLabel>
                    <TextareaInput
                        id="form-restricted-comment-description"
                        v-model="formDraft.restrictedComment.description"
                    />
                </div>
            </FormGroup>
        </div>
    </div>
</template>
